export enum RespondentState {
    None = 0,
    InProcess = 1,
    Canceled = 2,
    Completed = 3,
    Skipped = 4
}